import { jsx as _jsx } from "react/jsx-runtime";
export function BackgroundCard(param) {
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "rounded-lg border-[0.2px] border-border p-4 bg-card",
        children: children
    });
}
